import React, { useState } from 'react';
import { verifyOTP } from '../api/authApi';

const OTPVerificationModal = ({ email, otpId, onVerified, onClose }) => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!otp || otp.length < 4) {
      setError('Please enter a valid OTP');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const result = await verifyOTP(otpId, otp);

      if (result.success) {
        onVerified();
      } else {
        setError(result.message || 'OTP verification failed');
      }
    } catch (error) {
      console.error('OTP verification error:', error);
      setError('An unexpected error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content otp-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h4>Verify OTP</h4>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          <p className="text-center mb-3">
            An OTP has been sent to <strong>{email}</strong>
          </p>

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                className="form-control text-center"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  if (value.length <= 8) {
                    setOtp(value);
                    setError('');
                  }
                }}
                maxLength="8"
                autoFocus
              />
            </div>

            <div className="button-box mt-3">
              <button type="submit" disabled={loading || otp.length < 4}>
                {loading ? 'Verifying...' : 'Verify OTP'}
              </button>
            </div>
          </form>

          <div className="text-center mt-3">
            <small className="text-muted">
              Didn't receive the OTP? Check your spam folder or try registering again.
            </small>
          </div>
        </div>
      </div>

      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .modal-content {
          background: white;
          border-radius: 8px;
          max-width: 500px;
          width: 90%;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        }

        .modal-header {
          padding: 20px;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .modal-header h4 {
          margin: 0;
          font-size: 24px;
        }

        .close-btn {
          background: none;
          border: none;
          font-size: 32px;
          line-height: 1;
          cursor: pointer;
          color: #999;
          padding: 0;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .close-btn:hover {
          color: #333;
        }

        .modal-body {
          padding: 30px;
        }

        .otp-modal input {
          font-size: 24px;
          letter-spacing: 8px;
          text-align: center;
          padding: 15px;
        }

        .alert {
          padding: 12px;
          margin-bottom: 20px;
          border-radius: 4px;
        }

        .alert-danger {
          background-color: #f8d7da;
          border: 1px solid #f5c6cb;
          color: #721c24;
        }

        .button-box button {
          width: 100%;
          padding: 15px;
          background: #88c74a;
          color: white;
          border: none;
          border-radius: 4px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.3s;
        }

        .button-box button:hover:not(:disabled) {
          background: #75b339;
        }

        .button-box button:disabled {
          background: #ccc;
          cursor: not-allowed;
        }

        .text-muted {
          color: #6c757d;
        }
      `}</style>
    </div>
  );
};

export default OTPVerificationModal;
